import React, { useState } from 'react';
import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import { useResizablePanels } from './context';

export interface ResizablePanelsHandleProps extends Omit<BoxProps, 'onMouseDown'> {
  index: number;
}

export const ResizablePanelsHandle: React.FC<ResizablePanelsHandleProps> = ({
  index,
  className,
  ...boxProps
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const { onResizeStart } = useResizablePanels();

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    onResizeStart(index, e.clientX);
  };

  return (
    <Box
      height="100%"
      cursor="col-resize"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      userSelect="none"
      onMouseDown={handleMouseDown}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      _before={{
        content: '""',
        position: 'absolute',
        left: '50%',
        top: 0,
        bottom: 0,
        width: '1px',
        bg: isHovering ? 'purple.400' : '',
        transform: 'translateX(-50%)',
        transition: 'background-color 0.2s ease',
      }}
      _hover={{
        _before: {
          width: '2px',
          bg: 'purple.400',
        },
      }}
      _active={{
        _before: {
          width: '2px',
          bg: 'purple.500',
        },
      }}
      className={`ResizablePanelsHandle ${className ?? ''}`}
      {...boxProps}
    />
  );
};
